/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PPTLBaseMock, PPTLBaseMockInterface } from "../PPTLBaseMock";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "default_admin",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "salePrice",
        type: "uint256",
      },
    ],
    name: "royaltyInfo",
    outputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyAmount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "royaltyReceiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyPercentage",
        type: "uint256",
      },
    ],
    name: "setRoyaltyInfo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "roleId",
        type: "bytes32",
      },
    ],
    name: "senderProtected",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "roleId",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "adminRoleId",
        type: "bytes32",
      },
    ],
    name: "setRoleAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "exists",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type PPTLBaseMockConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: PPTLBaseMockConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class PPTLBaseMock__factory extends ContractFactory {
  constructor(...args: PPTLBaseMockConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "PPTLBaseMock";
  }

  deploy(
    default_admin: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<PPTLBaseMock> {
    return super.deploy(
      default_admin,
      overrides || {}
    ) as Promise<PPTLBaseMock>;
  }
  getDeployTransaction(
    default_admin: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(default_admin, overrides || {});
  }
  attach(address: string): PPTLBaseMock {
    return super.attach(address) as PPTLBaseMock;
  }
  connect(signer: Signer): PPTLBaseMock__factory {
    return super.connect(signer) as PPTLBaseMock__factory;
  }
  static readonly contractName: "PPTLBaseMock";
  public readonly contractName: "PPTLBaseMock";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): PPTLBaseMockInterface {
    return new utils.Interface(_abi) as PPTLBaseMockInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PPTLBaseMock {
    return new Contract(address, _abi, signerOrProvider) as PPTLBaseMock;
  }
}
